/**
 * Location-related constants
 */

/**
 * Distance threshold (in yards) for all location-gated actions — check-in
 * and opening a door from an active session both use the same radius.
 */
export const CHECK_IN_DISTANCE_THRESHOLD_YARDS = Infinity;
